// extracted by mini-css-extract-plugin
export default {"microsoftButton":"MicrosoftLoginButton_microsoftButton__06AqU","buttonLabel":"MicrosoftLoginButton_buttonLabel__euVGE"};